/**
 * PKCE primitives (RFC 7636) shared by every OAuth flow this app starts: the
 * browser SSO in `auth-tokens.ts` and the desktop shell's system-browser SSO
 * in `desktop/sso.ts`.
 */

function base64UrlEncode(bytes: ArrayBuffer): string {
  const arr = new Uint8Array(bytes);
  let str = "";
  for (let i = 0; i < arr.byteLength; i++) {
    str += String.fromCharCode(arr[i]);
  }
  return btoa(str).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}

export function randomUrlSafe(byteLength = 32): string {
  const bytes = new Uint8Array(byteLength);
  crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes.buffer);
}

/** The S256 `code_challenge` for a verifier. */
export async function sha256B64Url(input: string): Promise<string> {
  const hash = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(input));
  return base64UrlEncode(hash);
}
